import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button
} from '@mui/material';
import TabsPermissionMatrix from './TabsPermissionMatrix';

interface TabItem {
  _id: string;
  name: string;
  code: string;
}

interface TabsSelectionDialogProps {
  open: boolean;
  onClose: () => void;
  tabs: TabItem[];
  selectedTabs: string[];
  onSave: (selectedTabs: string[]) => void;
}

const TabsSelectionDialog: React.FC<TabsSelectionDialogProps> = ({
  open,
  onClose,
  tabs,
  selectedTabs,
  onSave
}) => {
  const [tempSelectedTabs, setTempSelectedTabs] = React.useState<string[]>(selectedTabs);

  React.useEffect(() => {
    if (open) {
      setTempSelectedTabs(selectedTabs);
    }
  }, [open, selectedTabs]);

  const handleSave = () => {
    onSave(tempSelectedTabs);
  };

  const handleCancel = () => {
    setTempSelectedTabs(selectedTabs);
    onClose();
  };

  return (
    <Dialog fullWidth maxWidth="xl" open={open} onClose={handleCancel}>
      <DialogTitle>Вибір дозволів доступу</DialogTitle>
      <DialogContent>
        <TabsPermissionMatrix
          tabs={tabs}
          selectedTabs={tempSelectedTabs}
          onChange={setTempSelectedTabs}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCancel}>
          Скасувати
        </Button>
        <Button color="primary" variant="contained" onClick={handleSave}>
          Зберегти
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TabsSelectionDialog;
